import { Box, Switch as ChakraSwitch, Text, useMediaQuery } from '@chakra-ui/react';
import { forwardRef } from 'react';

export const Switch = forwardRef((props, ref) => {
  const [isLargerThan1366] = useMediaQuery('(max-width: 1366px)');

  return (
    <Box display="flex" alignItems="center" gap={2}>
      {props.icon && props.icon}
      <Text
        fontSize="12px"
        fontWeight="normal"
        //diminue a fonte do texto do switch quando a tela é menor que 1366px
        {...(isLargerThan1366 && { fontSize: '10px' })}>
        {props.label}
      </Text>
      <ChakraSwitch
        colorScheme="blue"
        size="lg"
        ref={ref}
        defaultChecked={props.isChecked}
        isChecked={props.isChecked}
        {...props}
      />
    </Box>
  );
});
